import Swal from "sweetalert2";

export function errorAlerta(title, text) {
  Swal.fire({
    title,
    text,
    confirmButtonColor: "#2DCD22",
    confirmButtonText: "Continuar",
    icon: "error",
  }).then(() => {
    return true;
  });
}

export function advertenciaAlerta(title, text) {
  Swal.fire({
    title,
    text,
    confirmButtonColor: "#2DCD22",
    confirmButtonText: "Continuar",
    icon: "warning",
  }).then(() => {
    return true;
  });
}

export function exitosaAlerta(title, text) {
  Swal.fire({
    title,
    text,
    confirmButtonColor: "#2DCD22",
    confirmButtonText: "Continuar",
    icon: "success",
  }).then(() => {
    return true;
  });
}
